import * as React from 'react';

interface ILineItemProps {
    description: string;
    price: string;
    priceTypeDescription: string;
    onSelect: (e: any) => void;
    onRemove: (e: any) => void;
    isSelected: boolean;
}

// Cart line item
const LineItem: React.SFC<ILineItemProps> = (props) => {
    const { description, price, priceTypeDescription, onSelect, onRemove, isSelected } = props;
    const useTagClose = '<use xlink:href="#icon-close" />';

    return (
        <li className={"cart-item" + (isSelected ? " active" : "")}>
            <div className="cart-item-action">
                <svg className="cart-mini-close" dangerouslySetInnerHTML={{ __html: useTagClose }} onClick={onRemove} />

            </div>
            <div className="cart-item-content">
                <span className="cart-mini-item-section" onClick={onSelect}>{description}</span>
                <span className="cart-item-price-info">
                    <span>{priceTypeDescription}</span>
                    <span>{price}</span>
                </span>

            </div>
        </li>
    );
}

export default LineItem;